import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  what: [],
  where: {
    destinations: [],
    destinationsGroups: [],
  },
  when: {},
  who: {
    adults: 2,
    children: 0,
    rooms: 1,
    childAges: [],
  },
  budget: {
    min: 100,
    max: 3000,
  }
}

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    updateSearch: (state, action) => {
      return {
        ...state,
        ...action.payload
      }
    }
  },
})

export const {
  updateSearch,
} = searchSlice.actions;

export const selectSearch = state => state.search;

export default searchSlice.reducer;
